import {store} from '../redux/store'

/**
 * Function for translate localization.
 * @param {string} string - String to translate.
 * @param {string} vars - Variables to replace.
 */
export default (string: string = '', vars?: {[key: string]: string}): string => {
  const reduxStore: any = store.getState().reducer
  let resultStr = ''

  if ( reduxStore.lang === 'ru' )
    if ( localization[string] )
      resultStr = localization[string]
    else
      resultStr = string
  else
    resultStr = string

  if ( vars && Object.keys(vars).length ) {
    Object.keys(vars).forEach(key => {
      resultStr = resultStr.replace(`{${key}}`, vars[key])
    })
  }

  return resultStr
}

const localization: { [key: string]: string } = {
  'Extension': 'Расширение',
  'Learn how to make money': 'Заработок без вложений',
  'to Webmaster': 'Веб-мастеру',
  'Log in': 'Войти',
  'Log in ': 'Вход',
  'Sign up': 'Регистрация',
  'Sign up ': 'Зарегистрироваться',
  'Sign in': 'Авторизоваться',
  'Username': 'Логин',
  'Log in with Surfe.be': 'Войти через Surfe.be',
  'Recover your password': 'Восстановить пароль',
  'Reset your password': 'Сбросить пароль',
  'Finish': 'Завершить',
  'Continue': 'Продолжить',
  'Close': 'Закрыть',
  'Terms Of Service': 'Условия сервиса',
  'and': 'и',
  'Privacy Policy': 'Политика приватности',
  'Cookie Policy': 'Политика cookie',
  'Payment methods': 'Способы оплаты',
  'Webmasters': 'Веб-мастеру',
  'Sign in with social networks': 'Войти с помощью соцсетей',
  'Invalid login or password': 'Неверный логин или пароль',
  'Field can not be empty': 'Поле не может быть пустым',
  'Please, solve the captcha': 'Пожалуйста, решите капчу',
  'Login or e-mail': 'Логин или e-mail',
  'Username should contain at least 3 characters.': 'Значение «Имя пользователя» должно содержать минимум 3 символа.',
  'Username is too long': 'Имя пользователя слишком длинное',
  'Username is invalid.': 'Значение «Имя пользователя» неверно.',
  'Email is not a valid email address.': 'Значение «Email» не является правильным email адресом.',
  'Password': 'Пароль',
  'Login': 'Логин',
  'Failed to login': 'Ошибка при входе на сайт',
  'Failed to register': 'Ошибка при регистрации',
  'Forgot password?': 'Забыли пароль?',
  'Page not found': 'Страница не найдена',
  'Required params: user id and token': 'Отсутствуют обязательные параметры: id пользователя и токен',
  'Already registered? Sign in!': 'Уже зарегистрированы? Авторизуйтесь!',
  'Make sure it\'s': 'Пароль должен содержать',
  'Password must contain': 'Пароль должен содержать',
  'at least 8 characters': 'хотя бы 8 символов',
  'including a number': 'включать цифры',
  'and a letter': 'и буквы',
  'I agree with': 'Я принимаю',
  'Weak': 'Слабый',
  'Normal': 'Нормальный',
  'Good': 'Хороший',
  'Strong': 'Надежный',
  'Help': 'Помощь',
  'Need help?': 'Нужна помощь?',
  'Write to': 'Пишите на',
  'Code must be exactly 6 characters': 'Код должен содержать 6 символов',
  'You have activated two-factor authentication with {type}.': 'Вами была активирована двухфакторная авторизация через {type}.',
  'Enter 6-digit code from {type} message to enter profile': 'Введите 6-значный код из сообщения в {type}, чтобы войти в свой профиль',
  'Banner advertising placement service': 'Сервис размещения баннерной рекламы',
  'Password has been changed': 'Пароль был изменен',
  'An email has been sent with instructions for resetting your password': 'Вам отправлено письмо с инструкциями по смене пароля.',
  'Error accrued while sending email. Try again later.': 'Во время отправки письма произошла ошибка. Попробуйте позже.',
  'Error accrued while changing password. Try again later.': 'Во время смены пароля произошла ошибка. Попробуйте позже.',
}
